import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Heart, Clock3, LogIn, LogOut, User2, Sparkles } from "lucide-react";

export default function Header({ onOpenAuth }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-linen/70 border-b border-ink/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <div className="w-8 h-8 bg-ink text-linen grid place-items-center font-display font-black text-lg group-hover:bg-poppy transition-colors">
            S
          </div>
          <div className="flex items-baseline gap-1">
            <span className="font-display font-black tracking-tight text-xl">SHOPSCOPE</span>
            <span className="tape-label text-poppy hidden sm:inline">/ FR</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <NavLink
            to="/"
            data-testid="nav-discover"
            className={({ isActive }) =>
              `px-4 py-2 text-sm font-bold ${isActive ? "text-poppy" : "text-ink/70 hover:text-ink"}`
            }
          >
            Découvrir
          </NavLink>
          {user && (
            <>
              <NavLink
                to="/favoris"
                data-testid="nav-favorites"
                className={({ isActive }) =>
                  `px-4 py-2 text-sm font-bold flex items-center gap-1.5 ${
                    isActive ? "text-poppy" : "text-ink/70 hover:text-ink"
                  }`
                }
              >
                <Heart className="w-4 h-4" /> Favoris
              </NavLink>
              <NavLink
                to="/historique"
                data-testid="nav-history"
                className={({ isActive }) =>
                  `px-4 py-2 text-sm font-bold flex items-center gap-1.5 ${
                    isActive ? "text-poppy" : "text-ink/70 hover:text-ink"
                  }`
                }
              >
                <Clock3 className="w-4 h-4" /> Historique
              </NavLink>
            </>
          )}
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <div
                data-testid="user-chip"
                className="hidden sm:flex items-center gap-2 px-3 py-1.5 border border-ink/20"
              >
                <User2 className="w-4 h-4" />
                <span className="text-sm font-bold">{user.name?.split(" ")[0] || user.email}</span>
              </div>
              <button
                data-testid="logout-button"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                className="btn-ghost-brut px-3 py-2 text-sm flex items-center gap-1.5"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Quitter</span>
              </button>
            </>
          ) : (
            <button
              data-testid="open-auth-button"
              onClick={onOpenAuth}
              className="btn-brut px-4 py-2 text-sm flex items-center gap-1.5"
            >
              <Sparkles className="w-4 h-4" />
              Connexion
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
